<script setup lang="ts">
const props = defineProps<{
	step: number
	steps: number
	image?: string
	alt?: string
}>()

const getDotCssClass = (dot: number) => {
	switch (true) {
		case dot < props.step:
			return 'filled'
		case dot === props.step:
			return 'active'
		case dot > props.step:
		default:
			return 'outlined'
	}
}
</script>

<template>
	<div
		class="stepper ion-padding-bottom"
		:aria-description="`Schritt ${step} von ${steps}`"
	>
		<div
			v-for="dot in steps"
			:key="dot"
			:class="['stepper-dot', getDotCssClass(dot)]"
		/>
	</div>
</template>

<style lang="scss" scoped>
.stepper {
	display: flex;
	flex-direction: row;
	gap: 10px;
	justify-content: center;

	.stepper-dot {
		width: 12px;
		height: 12px;
		border: 1px solid var(--ion-color-primary-contrast);
		border-radius: 12px;
		&.filled {
			background:  var(--ion-color-primary-contrast);
		}
		&.active {
			background:  var(--ion-color-primary);
		}
	}
}
</style>
